import sizeFontCustom from '../Discovery/fontSize.styles';

const linkedAccountsSectionStyles = {
	buttonGroup: {
		justifyContent: 'flex-end',
		padding: '1rem',
		zIndex: 1051,
		position: 'fixed',
		display: 'flex',
	},
	mobileBottomStack: {
		position: 'fixed',
		bottom: 0,
		left: 0,
		right: 0,
		width: '100%',
		zIndex: 1051,
		boxSizing: 'border-box',
		paddingBottom: 'env(safe-area-inset-bottom, 0px)',
	},
	mobileFixedButtonGroup: {
		display: 'flex',
		gap: '1rem',
		justifyContent: 'space-between',
		flexWrap: 'wrap',
		width: '100%',
		padding: '1rem 1.5rem',
		boxSizing: 'border-box',
	},
	mobileContentPaddingWithActions:
		'calc(10.5rem + env(safe-area-inset-bottom, 0px))',
	mobileContentPaddingFooterOnly:
		'calc(4.5rem + env(safe-area-inset-bottom, 0px))',
	container: {
		flex: '2',
		display: 'flex',
		justifyContent: { xs: 'start', md: 'start' },
		flexDirection: 'column',
		minHeight: { xs: 'auto', md: '100vh' },
		alignItems: 'start',
		// overflowY:"scroll",
	},
	title: {
		fontWeight: '900',
	},
	subTitle: {
		...sizeFontCustom.heading,
		textAlign: 'left',
		margin: {
			xs: '-0.75rem 0 0.25rem 0.5rem',
			md: '-1rem 0 0 0',
		},
	},
	changeNumberLink: {
		cursor: 'pointer',
		textDecoration: 'none',
		fontWeight: '500',
		textTransform: 'capitalize',
		...sizeFontCustom.cardTitle,
	},
};
export default linkedAccountsSectionStyles;
